import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "pmfa_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems(prev => {
      const i = prev.findIndex(p => p.id === product.id);
      if (i >= 0) {
        const copy = [...prev];
        copy[i] = { ...copy[i], quantity: copy[i].quantity + qty };
        return copy;
      }
      return [...prev, { id: product.id, name: product.name, price: product.price, image_url: product.image_url, quantity: qty }];
    });
  };
  const update = (id, qty) => setItems(prev => prev.map(p => p.id === id ? { ...p, quantity: Math.max(1, qty) } : p));
  const remove = (id) => setItems(prev => prev.filter(p => p.id !== id));
  const clear = () => setItems([]);
  const total = items.reduce((s, p) => s + p.price * p.quantity, 0);
  const count = items.reduce((s, p) => s + p.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, update, remove, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
}
export const useCart = () => useContext(CartContext);
